import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import AuthCallback from "./pages/AuthCallback";
import Support from "./pages/Support";
import Privacy from "./pages/Privacy";
import Services from "./pages/Services";
import TeamPage from "./pages/TeamPage";
import PublicBooking from "./pages/PublicBooking";
import StaffPortal from "./pages/StaffPortal";
import AppLayout from "./pages/app/AppLayout";
import Dashboard from "./pages/app/Dashboard";
import Intake from "./pages/app/Intake";
import Appointments from "./pages/app/Appointments";
import Team from "./pages/app/Team";
import ClientsPage from "./pages/app/ClientsPage";
import FormsCenter from "./pages/app/FormsCenter";
import Office from "./pages/app/Office";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (location.state?.user) return children;
  if (user === null) {
    return (
      <div data-testid="auth-loading" className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/auth" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Check URL fragment (not query params) for session_id — synchronous during render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/services" element={<Services />} />
      <Route path="/team" element={<TeamPage />} />
      <Route path="/book" element={<PublicBooking />} />
      <Route path="/portal" element={<StaffPortal />} />
      <Route path="/support" element={<Support />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="intake" element={<Intake />} />
        <Route path="appointments" element={<Appointments />} />
        <Route path="clients" element={<ClientsPage />} />
        <Route path="forms" element={<FormsCenter />} />
        <Route path="team" element={<Team />} />
        <Route path="office" element={<Office />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="bottom-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
